import React, { Component } from 'react';
import DropDown from 'shared/components/DropDown/index';
import * as FontAwesome from 'react-icons/lib/fa';

export default class SubHeader extends Component {
  render() {
    const { show, year, prev_click, next_click, validator, selected_group, selected_facility,
      group_data, onGroupChange, facilitydata, onFacChange, btnFilterClick } = this.props;

    return (
      <div className="sched-card__header">

        <div className="sched-card__title-block">
          <h1 className="sched-card__title">Scheduling</h1>
          <p className="sched-card__subtitle">
            Use one operational view for pending, scheduled and overdue work instead of a sparse month grid.
          </p>
        </div>

        <div className="sched-header-controls">
          <div className="sched-header-controls__filters">

            <div>
              <div className="sched-header-select-wrap">
                <DropDown
                  name={"selected_group"}
                  value={selected_group}
                  data={group_data}
                  first_element={"--Select Group--"}
                  onChange={onGroupChange}
                />
              </div>
              <div style={{ minHeight: 16 }}>
                <span className="error-text">
                  {validator.message('selected_group', selected_group, 'required|gt:0', false, { default: 'This field is required.' })}
                </span>
              </div>
            </div>

            <div>
              <div className="sched-header-select-wrap">
                <DropDown
                  name={"selected_facility"}
                  value={selected_facility}
                  data={facilitydata}
                  first_element={"--Select Facility--"}
                  onChange={onFacChange}
                />
              </div>
              <div style={{ minHeight: 16 }}>
                <span className="error-text">
                  {validator.message('selected_facility', selected_facility, 'required', false, { default: 'This field is required.' })}
                </span>
              </div>
            </div>

            <div className="sched-year-nav">
              <button
                className={`sched-year-nav__btn${!show ? ' sched-year-nav__btn--disabled' : ''}`}
                onClick={show ? prev_click : undefined}
                type="button"
              >
                <FontAwesome.FaChevronCircleLeft />
              </button>
              <span className="sched-year-nav__label">{year}</span>
              <button
                className={`sched-year-nav__btn${!show ? ' sched-year-nav__btn--disabled' : ''}`}
                onClick={show ? next_click : undefined}
                type="button"
              >
                <FontAwesome.FaChevronCircleRight />
              </button>
            </div>

            <button className="sched-apply-btn" onClick={btnFilterClick} type="button">
              Apply
            </button>

          </div>
        </div>

        <div className="sched-status-legend">
          <span className="sched-status-legend__item">
            <span className="sched-status-dot sched-status-dot--unassigned" />
            Scheduled
          </span>
          <span className="sched-status-legend__item">
            <span className="sched-status-dot sched-status-dot--assigned" />
            Assigned
          </span>
          <span className="sched-status-legend__item">
            <span className="sched-status-dot sched-status-dot--inprogress" />
            In Progress
          </span>
          <span className="sched-status-legend__item">
            <span className="sched-status-dot sched-status-dot--abandoned" />
            Abandoned
          </span>
          <span className="sched-status-legend__item">
            <span className="sched-status-dot sched-status-dot--completed" />
            Completed
          </span>
        </div>

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/shared/containers/PeriodicalScheduling/periodical_subheader.js